import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private DataSourceMap: any = {};
  public DataMap: any = {};
  private Data: any = {};

  private DataObservableSourceMap: any = {};
  public DataObservables: any = {};

  public initialize() {
    this.configureDataSourceMap();

    this.configureObservablesMap();

    this.configureData();
  }

  private configureDataSourceMap() {
    this.DataSourceMap.App = new BehaviorSubject(null);
    this.DataMap.App = this.DataSourceMap.App.asObservable();

    this.DataSourceMap.AIChatSession = new BehaviorSubject(null);
    this.DataMap.AIChatSession = this.DataSourceMap.AIChatSession.asObservable();

    this.DataSourceMap.Blueprint = new BehaviorSubject(null);
    this.DataMap.Blueprint = this.DataSourceMap.Blueprint.asObservable();
  }

  private configureObservablesMap() {
    this.DataObservableSourceMap.refreshAppInfo = new BehaviorSubject({ isEmpty: true });
    this.DataObservables.refreshAppInfo = this.DataObservableSourceMap.refreshAppInfo.asObservable();
  }

  private configureData() {
    this.Data = {
      AIChatSession: {
        type: 'array',
        isItemsFilled: false,
        items: []
      },
      SystemBP_PC: {
        type: 'json',
        isItemsFilled: false,
        items: {}
      },
      SystemBP_FD: {
        type: 'json',
        isItemsFilled: false,
        items: {}
      },
      SessionBP_PC: {
        type: 'json',
        isItemsFilled: false,
        items: {}
      },
      SessionBP_FD: {
        type: 'json',
        isItemsFilled: false,
        items: {}
      },
      App: {
        type: 'json',
        isItemsFilled: false,
        items: {}
      }
    };
  }

  public updateDataSource(thatParams) {
    let thatData = this.Data[thatParams.name];

    if (thatData) {
      if (thatData.type === 'array') {
        // Preferred Map version, to overcome repeated find() calls and it scales better with large session-array
        const tempDataMap = new Map(thatData.items.map((item) => [item.sid, item]));

        thatParams?.tuplesMap?.removed?.forEach((removedItem) => tempDataMap.delete(removedItem.sid));

        thatParams?.tuplesMap?.modified?.forEach((modifiedItem) => {
          if (tempDataMap.has(modifiedItem.sid)) {
            tempDataMap.set(modifiedItem.sid, {
              ...tempDataMap.get(modifiedItem.sid)!,
              ...modifiedItem
            });
          }
        });

        thatParams?.tuplesMap?.added?.forEach((addedItem) => {
          tempDataMap.set(addedItem.sid, addedItem);
        });

        this.Data[thatParams.name].items = [...tempDataMap.values()].sort(
          (a: any, b: any) => new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime()
        );
      } else if (thatData.type === 'json') {
        thatParams?.tuplesMap?.removed?.forEach((removedItem) => {
          delete this.Data[thatParams.name].items[removedItem._primaryId];
        });

        thatParams?.tuplesMap?.modified?.forEach((modifiedItem) => {
          this.Data[thatParams.name].items[modifiedItem._primaryId] = {
            ...(this.Data[thatParams.name].items[modifiedItem._primaryId] || {}),
            ...modifiedItem
          };
        });

        // Added, Modified > both are same
        thatParams?.tuplesMap?.added?.forEach((addedItem) => {
          this.Data[thatParams.name].items[addedItem._primaryId] = {
            ...addedItem
          };
        });
      }

      this.Data[thatParams.name].isItemsFilled = true;
    }
  }

  public triggerDataSource(thatParams) {
    this.DataSourceMap[thatParams.name].next({});
  }

  public getDataSource(thatParams: any) {
    let thatData: any = this.Data[thatParams.name];

    if (thatData) {
      if (thatData.isItemsFilled) {
        if (thatData.type == 'array') {
          const clonedData: any = JSON.parse(JSON.stringify(thatData.items || []));
          return {
            dataSourceExist: true,
            isItemsFilled: true,
            data: clonedData
          };
        } else if ((thatData.type = 'json')) {
          const clonedData: any = JSON.parse(JSON.stringify(thatData.items || {}));
          return {
            dataSourceExist: true,
            isItemsFilled: true,
            data: clonedData
          };
        } else {
          // short-circuit break
          return {
            dataSourceExist: false,
            isItemsFilled: false
          };
        }
      } else {
        return {
          dataSourceExist: true,
          isItemsFilled: false
        };
      }
    } else {
      return {
        dataSourceExist: false
      };
    }
  }

  public clearDataSource(thatParams: any) {
    let thatData = this.Data[thatParams.name];

    if (thatData) {
      thatData.isItemsFilled = false;

      if (thatData.type === 'array') {
        thatData.items = [];
      } else if (thatData.type === 'json') {
        thatData.items = {};
      }
    }
  }

  triggerObservableSource(thatParams: any) {
    this.DataObservableSourceMap[thatParams.name].next({
      isEmpty: false
    });
  }
}
